/**
 * Licensed Materials - Property of IBM
 * IBM Watson Analytics (C) Copyright IBM Corp. 2016, 2017
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define(['./LayoutBaseView'],
	function(BaseLayout) {

		var SinglePage = null;
		SinglePage = BaseLayout.extend({

			init: function() {
				SinglePage.inherited('init', this, arguments);

				this.layoutController.layoutReady(this.model.id).done(function(){
					var layoutView = this.layoutController.getLayoutView(this.model.id);
					layoutView.onShow();
				}.bind(this));
			},

			/**
		 * Get selected layout model
		 *
		 * @return {Model} - selected layout model
		 */
			getSelectedLayout: function() {
				return this.model.items[0];
			}
		});

		return SinglePage;
	});
